import script from "./FontBackgroundSelector.vue?vue&type=script&setup=true&lang=ts"
export * from "./FontBackgroundSelector.vue?vue&type=script&setup=true&lang=ts"

import "./FontBackgroundSelector.vue?vue&type=style&index=0&id=0801c96a&lang=scss"

const __exports__ = script;

export default __exports__